module.exports = "/img/_/_/_/assets/images/creeper/battle/common//36.jpg?6af72f51ce9be9f7eae237179583c35b";